function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrialPeriods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Menu - Trial periods",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 5.225A5.225 5.225 0 1 0 5 6.819L.208 11.608a.712.712 0 0 0-.208.5v2.375a.711.711 0 0 0 .713.712h2.375a.711.711 0 0 0 .713-.712V13.3h1.187a.711.711 0 0 0 .712-.713V11.4h1.188a.712.712 0 0 0 .5-.208l.989-.989a5.38 5.38 0 0 0 1.143.229 5.226 5.226 0 0 1 5.2-4.732c.151 0 .3.006.451.021.02-.164.029-.327.029-.496zM11.163 2.85a1.182 1.182 0 0 1 1.027.594 1.185 1.185 0 1 1-1.027-.594zm-.712 8.075a4.275 4.275 0 1 1 4.274 4.275 4.276 4.276 0 0 1-4.275-4.275zm4.75-2.9a.475.475 0 0 0-.95 0v2.9a.476.476 0 0 0 .475.475h2.424a.475.475 0 0 0 0-.95H15.2z",
    transform: "translate(3 4)",
    style: {
      fill: "#a9b0b3"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrialPeriods);
export default __webpack_public_path__ + "static/media/IconTrialPeriods.96cf48e0133a457947b1757f74a044fa.svg";
export { ForwardRef as ReactComponent };